module.exports = __webpack_public_path__ + "static/media/block_successfully.d41d7f70.svg";